import { Fragment } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Icon } from '../../../ui';
import { REQUIRED_FIELD_LABELS, type RequiredFieldKey } from './types';

interface RequiredFieldsStatusProps {
    missing: Array<RequiredFieldKey>;
    onFieldClick: (key: RequiredFieldKey) => void;
}

const RequiredFieldsStatus = ({ missing, onFieldClick }: RequiredFieldsStatusProps) => {
    if (missing.length === 0) {
        return (
            <Flex align="center" gap={1.5} color="success.fg">
                <Icon name="checkCircle" size="sm" />
                <Text fontSize="sm" color="fg.muted">
                    All required fields complete
                </Text>
            </Flex>
        );
    }

    return (
        <Box minW={0} maxW={{ base: '11rem', sm: '15rem' }} aria-live="polite">
            <Text fontSize="sm" fontWeight="semibold" color="fg.default">
                {missing.length} required field{missing.length === 1 ? '' : 's'} left
            </Text>
            <Text fontSize="xs" color="fg.muted" whiteSpace="normal">
                {missing.map((key, i) => (
                    <Fragment key={key}>
                        {i > 0 && ', '}
                        <Button
                            variant="link"
                            size="xs"
                            fontWeight="medium"
                            verticalAlign="baseline"
                            onClick={() => onFieldClick(key)}
                        >
                            {REQUIRED_FIELD_LABELS[key]}
                        </Button>
                    </Fragment>
                ))}
            </Text>
        </Box>
    );
};

export default RequiredFieldsStatus;
